import React, { useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Accordion from '../../../../components/Accordion';
import FormContainer from '../../../../components/FormContainer';
import AddressCard from '../../../../components/Cards/AddressCard';
import Select from '../../../../components/Inputs/Select';
import Button from '../../../../components/Button';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';
import { formatMoney } from '../../../../utils/formatValues';
import createPayload from './createPayload';

import validate from '../../../../utils/validateForm';

import Alert from '../../../../components/Alert';
import { solicitaSegundaViacarteiras } from '../../../../services/v3/beneficiario';
import { useDependentsList } from './useDependentsList';
import TabMenu from '../../../../components/TabMenu';
import { solicitacaoSegundaViaTabs } from '../Tabs';
import { getTipoAtendimento } from '../../../../services/contrato/contatos';
import { useGlobal } from '../../../../contexts/Global/context';
import { checkIsSupport } from '../../../../utils';

function SegundaVia({ location: { dataBeneficiario, endereco, reasonAndCostCard, dependentsList, addressType } }) {
    const { dataActiveContract, setShowSupportModal } = useGlobal();
    const history = useHistory();
    const [planType, setPlanType] = useState('');
    const [renderDependentsList, dependents, setIsCongenerExclusive] = useDependentsList(dependentsList);
    const [loadingPost, setLoadingPost] = useState(false);
    const [alerts, setAlerts] = useState([]);
    // TODO DUPLICATED VAR
    // const [cardCost] = useState(formatMoney(0));
    const [dataForm, setDataForm] = useState({
        reason: {
            id: 'reason',
            label: 'Motivo',
            required: true,
            options: reasonAndCostCard.map(({ motivo, cartao, possuiCobranca }) => ({
                ...motivo,
                cartao,
                possuiCobranca,
            })),
        },
        issuedBy: {
            id: 'issuedBy',
            label: 'Emitido por',
            required: true,
            options: [
                { codigo: 'O', nome: 'GNDI' },
                { codigo: 'C', nome: 'Congênere' },
                { codigo: 'A', nome: 'Ambas' },
            ],
            value: 'C',
        },
        dependents: {
            id: 'dependents',
            label: '',
            required: false,
        },
    });

    const cardCost = formatMoney(dataForm.reason.cartao?.valor);
    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = { ...dataForm };

        // if (id === 'reason') {
        // Regra comentada até definição da GNDI para as regras de retorno desse valor
        // const newReason = form.reason.options.find((reason) => reason.codigo === value);

        // setCardCost(
        //     formatMoney(
        //         dataActiveContract.cobraEmissaoCarteira && newReason.possuiCobranca ? newReason.cartao?.valor : 0
        //     )
        // );
        // }

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    function handleChangeInput(event) {
        const { id, value, unmaskedValue, cartao } = event;

        const field = { ...dataForm[id], value, unmaskedValue, error: '', cartao };

        setDataForm({
            ...dataForm,
            [id]: field,
        });
    }

    function setError(errorMessage) {
        setAlerts([
            {
                type: 1,
                title: errorMessage,
            },
        ]);

        setTimeout(() => {
            window.document.getElementById('page-content').scrollTo(0, 0);
        }, 100);
    }

    async function handleStepForward() {
        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (!isValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError)
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
            }, 100);

            setLoadingPost(false);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoadingPost(true);

        const payload = createPayload({ dataBeneficiario, dataForm, addressType, dependents });
        const responseSegundaVia = await solicitaSegundaViacarteiras({ segundaViaCarteira: payload });

        if (!responseSegundaVia) {
            setError('Algo deu errado! Por favor, tente novamente!');
            setLoadingPost(false);
            return;
        }
        if (!responseSegundaVia.results?.sucesso) {
            setError(responseSegundaVia.mensagemRetorno);
            setLoadingPost(false);
            return;
        }

        if (responseSegundaVia.results.segundaViaCarteira.length > 0) {
            let errorRequest = false;
            responseSegundaVia.results.segundaViaCarteira.forEach((result) => {
                if (!result.sucesso) {
                    errorRequest = true;
                    setAlerts([
                        ...alerts,
                        {
                            type: 1,
                            title: result.mensagemRetorno,
                        },
                    ]);
                }
            });

            if (errorRequest) {
                setLoadingPost(false);
                return;
            }
        }

        setLoadingPost(false);
        history.push('/dados_beneficiario/sucesso_solicitacao');
    }

    useEffect(() => {
        async function setTipoAtendimento() {
            const { isContratoRepasse, codigoPlano } = dataBeneficiario;
            // const {
            //     data: {
            //         results: { tipoAtendimento },
            //     },
            // } = await getTipoAtendimento(dataActiveContract.numero, codigoPlano);
            const responseTipoAtendimento = await getTipoAtendimento(dataActiveContract.numero, codigoPlano);
            // if(!isContratoRepasse) {
            //     setPlanType("Congênere");
            //     setDataForm({ ...dataForm, issuedBy: { ...dataForm.issuedBy, value: 'C' } });
            //     return;
            // }
            if (!isContratoRepasse) {
                setPlanType('GNDI');
                setDataForm({ ...dataForm, issuedBy: { ...dataForm.issuedBy, value: 'O' } });
                return;
            }

            if (responseTipoAtendimento.data) {
                const { tipoAtendimento } = responseTipoAtendimento.data.results;

                if (tipoAtendimento === 'Exclusivo Congênere') {
                    setIsCongenerExclusive(false);
                    setPlanType(`Congênere`);
                    setDataForm({ ...dataForm, issuedBy: { ...dataForm.issuedBy, value: 'C' } });
                }
                setPlanType(tipoAtendimento);
                if (tipoAtendimento === 'Porta Dupla') {
                    setIsCongenerExclusive(false);
                    setPlanType(tipoAtendimento);
                    setDataForm({ ...dataForm, issuedBy: { ...dataForm.issuedBy, value: 'A' } });
                }
                if (tipoAtendimento === 'GNDI') {
                    setIsCongenerExclusive(false);
                    setPlanType(tipoAtendimento);
                    setDataForm({ ...dataForm, issuedBy: { ...dataForm.issuedBy, value: 'O' } });
                }
            }
        }
        setTipoAtendimento();
    }, []);

    const isIssuedByDisabled = useMemo(() => planType !== 'Porta Dupla', [planType]);

    return (
        <PageContainer>
            {alerts.map((alert, index) => (
                <Alert key={() => index} {...alert} />
            ))}

            <TabMenu components={solicitacaoSegundaViaTabs} />

            <Accordion title="Dados do beneficiário" hasCollapse={false}>
                <FormContainer>
                    <S.CustomInput
                        field={{
                            id: 'numBadge',
                            label: 'Nº da carteirinha',
                            disabled: true,
                            value: dataBeneficiario.numCarteirinha,
                        }}
                        onBlur={handleInputBlur}
                    />
                    <S.CustomInput
                        field={{
                            id: 'fullName',
                            label: 'Nome completo',
                            disabled: true,
                            value: dataBeneficiario.nomeCompleto,
                        }}
                    />
                    <S.CustomInput
                        field={{
                            id: 'planType',
                            label: 'Tipo de plano',
                            disabled: true,
                            value: planType,
                        }}
                    />
                    <S.CustomInput
                        field={{
                            id: 'cardCost',
                            label: 'Custo do cartão',
                            disabled: true,
                            value: cardCost,
                        }}
                    />
                    <Select
                        field={{ ...dataForm.issuedBy, disabled: isIssuedByDisabled }}
                        onChange={handleChangeInput}
                        onBlur={handleInputBlur}
                    />
                    <Select field={dataForm.reason} onChange={handleChangeInput} onBlur={handleInputBlur} />
                </FormContainer>
            </Accordion>
            {dependentsList.length > 0 && dataBeneficiario.tipo === 'TITULAR' && renderDependentsList()}

            <Accordion title="Escolha o endereço de entrega" hasCollapse={false}>
                <FormContainer>
                    <AddressCard title={addressType.nome} endereco={endereco} />
                </FormContainer>
            </Accordion>
            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingPost}
                    disabled={loadingPost}
                    onClick={handleStepForward}
                >
                    Finalizar
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default SegundaVia;
